import React, { memo } from "react";
import { withNamespaces } from "react-i18next";
import { Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { RiRobotLine } from "react-icons/ri";

const LiaUserResponseConfirmationModal = ({
  t,
  isOpen,
  toggle,
  onConfirm,
  isLoading = false,
  showLegitimationWarning = false,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle}>{t("Generate response?")}</ModalHeader>

      <ModalBody>
        <div className="text-center">
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
            style={{
              width: 72,
              height: 72,
              background: "rgba(13, 110, 253, 0.1)",
            }}
          >
            <RiRobotLine size={36} className="text-primary" />
          </div>

          <h5 className="mb-3">{t("Generate response")}</h5>

          <p className="text-muted mb-0">
            {t(
              "AI will draft a reply to the data subject based on the case workflow. Review the preview before copying to Messages."
            )}
          </p>

          {showLegitimationWarning && (
            <Alert color="warning" className="mt-3 mb-0 text-start">
              {t(
                "Identity is not verified yet. The draft may include verification steps. Review carefully before sending."
              )}
            </Alert>
          )}
        </div>
      </ModalBody>

      <ModalFooter>
        <Button color="light" onClick={toggle} disabled={isLoading}>
          {t("Cancel")}
        </Button>

        <Button color="primary" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? t("Generating...") : t("Generate with AI")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default withNamespaces()(memo(LiaUserResponseConfirmationModal));
